<template>
  <div>
    <h1> My Profile</h1>
    <span>{{user.user.firstName}}</span>
    <span>{{user.user.lastName}}</span>
    <h2> Emails: </h2>
    <div v-for='e in user.emails' :key='e.address'>{{e.address}}</div>
    <h2> Organizations: </h2>
    <div v-for='org in user.organizations' :key='org.organization_id'>
      <hr/>
      <div>
        <h3>{{org.name}}</h3>
      </div>
      <div>
        <button class="btn-secondary" @click='createInvite(org.organization_id)'>Create Invite</button>
        <button class="btn-secondary" @click="deleteOrganization(org.organization_id)">Delete</button>
      </div>
      <div>
        <h3>invites:</h3>
        <div v-for="invite in org.invites" :key='invite'>{{invite}}</div>
      </div>
      <hr/>
    </div>
    <div>
      <input v-model="newOrgName" type='text'>
      <button class="btn-secondary" @click="createOrganization(newOrgName)">Create Organization</button>
    </div>
    <div>
      <input v-model="inviteCode" type='text'>
      <button class="btn-secondary" @click="joinOrganization(inviteCode)">Join Organization</button>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      user: {
        emails: [],
        organizations: [],
        user: {
          id: null,
          firstName: null,
          lastName: null
        }
      },
      inviteCode:"",
      newOrgName: ""
    };
  },
  methods: {
    joinOrganization: function(code) {
      flink.organization
        .addUser({ inviteCode: code, userId: this.user.user.id })
        .then(this.getUser);
    },
    createInvite: function(id) {
      flink.organization
        .createInvite({ orgId: id, creatorId: this.user.user.id })
        .then(this.getUser);
    },
    deleteOrganization: function(id) {
      flink.organization.del({ orgId: id }).then(this.getUser);
    },
    createOrganization: function(name) {
      flink.organization
        .create({ name: name, userIds: [this.user.user.id] })
        .then(this.getUser);
    },
    getUser: function() {
      flink.user.get({ userId: null }).then(user => {
        this.user = user;
      });
    }
  },
  mounted: function() {
    this.getUser();
  },
  components: {
  }
};
</script>

<style scoped lang='scss'>

</style>



// WEBPACK FOOTER //
// src/components/profile.vue